import { COMBAT_AI_PROPERTIES, type CharacterDef } from '../characters/types';
import {
  duelLevelForSkill,
  duelLevelSkill,
  skillProfile,
  type ArenaAiSkill,
  type SkillProfile,
} from './aiSkill';

/** Saved percentages belong to this game's roster, never to another original/template. */
export function characterAiProfile(character: CharacterDef, skill: ArenaAiSkill): SkillProfile {
  const level = duelLevelForSkill(skill);
  const base = skillProfile(skill);
  if (level === 'expert') return base;
  const own = character.combat?.aiLevels?.[level];
  if (!own) return base;
  const expert = skillProfile(duelLevelSkill('expert'));
  for (const key of COMBAT_AI_PROPERTIES) {
    if (own[key] !== undefined) base[key] = expert[key] * own[key]!;
  }
  for (const key of ['anticipation', 'lead', 'notice', 'carefulBelow', 'weave'] as const)
    base[key] = Math.min(1, base[key]);
  return base;
}
